import React, { useEffect, useState } from 'react';
import Loader from '../../components/Loader';
import FastPayment from '../FastPayment';
import StepPayment from '../StepPayment';
import PaymentCheck from '../PaymentCheck';
import CheckLogin from '../CheckLogin';
import { STEPS } from '../../utils/constants';
import { getParamFromUrl } from '../../utils/helpers';
import { useStateContext } from '../../context/StateContext';
import { getPageSettingsData, getOverviewData, getPaymentResult } from '../../services/PaymentApiService';
import {
	updateCurrentStepState,
	updateOverviewState,
	updatePageSettingsState,
	updateResultDataState,
	updateStepsLockedState
} from '../../reducers/actions';
import style from './home.module.scss';

const Home = () => {
	const { state, dispatch } = useStateContext();
	const { pageSettings, overview: { totalPaymentPrice = 0 } = {} } = state;
	const paymentId = getParamFromUrl('paymentId');
	const resultId = getParamFromUrl('resultId');
	const [isLoaderActive, setIsLoaderActive] = useState(resultId);

	useEffect(() => {
		requestPageSettingsData(paymentId || resultId);
	}, []);

	useEffect(() => {
		updateStepsLockedState({ payload: totalPaymentPrice === 0, dispatch });
	}, [totalPaymentPrice]);

	const requestPageSettingsData = id => {
		getPageSettingsData({ id }).then(res => {
			updatePageSettingsState({ payload: res, dispatch });

			if (resultId) {
				requestResultData({ id, useFastPay: res?.useFastPay });
			} else {
				requestOverviewData({ id, useFastPay: res?.useFastPay });
			}
		});
	};

	const requestOverviewData = ({ id, useFastPay }) => {
		getOverviewData({ id })
			.then(res => {
				const totalPaymentPrice = useFastPay
					? res?.paymentLinkOverviewDetailResult?.reduce((prevValue, nextItem) => prevValue + nextItem?.totalPrice, 0)
					: 0;

				const overviewDetail = res?.paymentLinkOverviewDetailResult?.map(item => {
					return {
						...item,
						isChecked: useFastPay,
						paymentPrice: item?.totalPrice
					};
				});

				const overview = {
					...res,
					overviewDetail,
					totalPaymentPrice
				};

				updateOverviewState({ payload: overview, dispatch });
			});
	};

	const requestResultData = ({ id, useFastPay }) => {
		getPaymentResult({ id })
			.then(res => {
				updateResultDataState({ payload: res, dispatch });

				if (!res?.status || res?.status === 'failure') {
					requestOverviewData({ id, useFastPay });
				}
			})
			.finally(() => {
				setIsLoaderActive(false);
				if (!pageSettings?.useFastPay) {
					updateCurrentStepState({ payload: STEPS.RESULT, dispatch });
				}
			});
	};

	if (isLoaderActive) {
		return (
			<div className={style.container}>
				<Loader />
			</div>
		);
	}

	return (
		<div className={style.container}>
			{pageSettings && (
				<div className={style.content}>
					{!pageSettings?.checkExpriredDate ? <CheckLogin/> : // linkin süresi dolup dolmadı
						!pageSettings?.checkRoutePaymentPage ? <PaymentCheck/> : // daha önce ödeme yaptı yapmadı
							pageSettings?.useFastPay ? <FastPayment resultId={resultId} /> : <StepPayment/> // normal sürec
					}
				</div>
			)}
		</div>
	);
};

export default Home;
